import React from "react";
import { Link } from "react-router-dom";

export const About = () => {
  return (
    <div id="about" className="about">
      <div className="title">About Me</div>
      <div className="about-container">
        <div className="text">
          <div>
            After attending Indiana University, Alice relocated to Los Angeles,
            California to pursue her career in beauty. She graduated from Yamano
            Beauty College, earned her esthetics license, and began working
            closely with spa clientele. Through this experience, Alice perfected
            the art of eyebrow shaping and skincare, and expanded her expertise
            to include professional makeup artistry.
          </div>
          <br />
          <div>
            Alice has worked with leading photographers on photoshoots, bridal
            parties, and advertising campaigns, continuously refining her craft.
            Her passion for hair styling later led her to obtain her cosmetology
            license, allowing her to offer a full range of services as a hair
            stylist, makeup artist, and esthetician.
          </div>
          <br />
          <div>
            With over 20 years of experience in the beauty industry, Alice is
            passionate about helping clients look and feel their best. When
            she’s not working in the salon, she runs a boutique freelance
            business from her relaxing private studio. Explore the space and
            learn more via the link below.
          </div>
          <br />
          <Link to="/studio">
            <button className="studio-btn">The Studio</button>
          </Link>
        </div>
        <div className="image-section">
          <img src="/images/portfolio-pic1.jpg" alt="alice montana" />
        </div>
      </div>
    </div>
  );
};
